import React, { FC } from 'react';

import { GoogleMap, GoogleMapCoord, MappableItem } from './GoogleMap';

interface ProfileGoogleMapProps {
  mapStyle: { [key: string]: string };
  center?: GoogleMapCoord;
  mappableItems?: MappableItem[];
}

export const ProfileGoogleMap: FC<ProfileGoogleMapProps> = ({
  mapStyle,
  center,
  mappableItems = [],
}: ProfileGoogleMapProps) => {
  const handleLoad = (map: google.maps.Map) => {
    const bounds = new google.maps.LatLngBounds();

    mappableItems.forEach((mappableItem: MappableItem) =>
      bounds.extend({
        lat: mappableItem.position.lat,
        lng: mappableItem.position.lng,
      }),
    );

    // fitBounds is asynchronous so unfortunately the recommended way to adjust
    // zoom after fitting the bounds, is to set up a one time listener.
    google.maps.event.addListenerOnce(
      map,
      'bounds_changed',
      function (event: any) {
        // Zoom out once to remove any markers on the edges.
        const zoom = map.getZoom();

        if (zoom === undefined) {
          return;
        }

        // If there's only one item, fitBounds zooms in way too much.
        if (mappableItems.length === 1 || zoom > 15) {
          map.setZoom(15);
          return;
        }

        // If there are too many items to bound, the zoom can go too far out.
        // in this case center to the US and just zoom a little in.
        if (zoom <= 3) {
          map.setZoom(3);
          return;
        }

        if (zoom >= 8) {
          // zoom in a few clicks
          map.setZoom(zoom + 2);
        }
      },
    );

    if (center) {
      map.setCenter(center);
    }

    map.fitBounds(bounds);
  };

  return (
    <GoogleMap
      mapStyle={mapStyle}
      center={center}
      mappableItems={mappableItems}
      handleLoad={handleLoad}
    />
  );
};
